import { UserRound } from "lucide-react";

import { Badge } from "components/ui/badge";

import { isPersonalised, segments } from "../announcement-placeholders";

/**
 * An announcement's title or body exactly as the organiser typed it, with
 * each placeholder marked, so the sent and scheduled lists show the template
 * rather than any one person's copy (TNG-95).
 */
export function TemplateText({ text }: { text: string }) {
  return (
    <>
      {segments(text).map((segment, index) =>
        segment.kind === "placeholder" ? (
          <mark
            // Segments are positional and never reorder.
            key={index}
            className="rounded bg-status-info/25 px-1 font-mono text-[0.9em] text-foreground"
            data-testid="template-placeholder"
          >
            {segment.raw}
          </mark>
        ) : (
          <span key={index}>{segment.raw}</span>
        ),
      )}
    </>
  );
}

/** Said beside a message that is filled in per recipient. */
export function PersonalisedBadge({
  title,
  body,
}: {
  title: string;
  body: string;
}) {
  if (!isPersonalised(title) && !isPersonalised(body)) return null;
  return (
    <Badge variant="info" className="gap-1" data-testid="personalised-badge">
      <UserRound className="h-3 w-3" aria-hidden />
      Personalised
    </Badge>
  );
}
